export default "__VITE_ASSET__jjcEXT0O__"